import React, { useEffect } from 'react'
import BgLayout from '../Components/Background/BgLayout'
import DownloadLine from '../Components/Download/DownloadLine'
import { Box, Container, Grid, useMediaQuery } from '@mui/material'
import { theme } from '../App';
import Navbar, { NAVBAR_SPACE } from '../Components/Navbar/Navbar';
import TitleTextLayout from '../Components/Background/TitleTextLayout';
import Advantages from '../Components/Advantages/Advantages';
import Description from '../Components/Description/Description';
import AppOffers from '../Components/AppOffers/AppOffers';
import OftenAsked from '../Components/OftenAsked';
import { LogAnalytics } from '../Classes/firebase';
import Ratings from '../Components/Ratings/Ratings';
import PartnersLine from '../Components/PartnersLine/PartnersLine';
import Banner from '../Components/Banner';

function DoplnekIcon({ sx }) {
    let editedIcon = React.cloneElement(<></>, {
        style: {
            maxWidth: "100%",
            height: "auto",
            ...sx,
        },
    });

    return editedIcon;
}

function isAppleDevice() {
    const platform = navigator.platform.toLowerCase();
    const userAgent = navigator.userAgent.toLowerCase();

    return (
        /mac/.test(platform) ||                   // macOS
        /iphone|ipad|ipod/.test(userAgent) ||     // iOS devices
        // iPadOS 13+ returns "MacIntel" platform, so check for multitouch
        (platform === 'macintel' && navigator.maxTouchPoints > 1)
    );
}


export default function AppPage({ appPageData = null }) {
    const mobile = useMediaQuery(theme.breakpoints.only("xs"));
    const tablet = useMediaQuery(theme.breakpoints.only("sm"));
    const underSevenHundred = useMediaQuery("(max-width:700px)");

    function getPlatformLink() {
        return isAppleDevice() ? appPageData.appstoreLink : appPageData.googleLink;
    }

    useEffect(() => {
        if (localStorage && !localStorage.getItem("firstStart")) {
            LogAnalytics("first_visit_app", { link: appPageData.link });
            localStorage.setItem("firstStart", 1);
        }
    }, [])

    return (
        <div>
            <Banner appPageData={appPageData} shopLink={getPlatformLink()} />
            <Navbar color={appPageData.color} />
            <BgLayout color={appPageData.color}>
                <Grid
                    maxWidth={1200}
                    container
                    columns={24}
                    sx={{
                        mt: { xs: "20px", sm: "40px", md: "40px" },
                        px: NAVBAR_SPACE,
                    }}
                >
                    <Grid size={{ xs: 24, sm: 24, md: 12 }} sx={{}}>
                        <Box sx={{}}>
                            <TitleTextLayout
                                smTitle={appPageData.smTitle}
                                title={appPageData.title}
                                text={appPageData.text}
                                buttonText={appPageData.buttonText}
                                sxTitle={{ maxWidth: { xs: "376px", sm: "400px" } }}
                                sxText={{ maxWidth: "240px" }}
                                openPath={getPlatformLink()}
                            />

                        </Box>
                    </Grid>
                    <Grid

                        size={{ xs: 0, sm: 0, md: 12 }}
                        sx={{
                            display: "flex",
                            justifyContent: { xs: "center", sm: "flex-end" },


                        }}
                    >
                        {<picture>
                            <source srcSet={appPageData.img} type="image/webp" />
                            <Box
                                component="img"
                                alt="Ukázka"
                                src={appPageData.img}
                                sx={[
                                    {
                                        position: "absolute",
                                        maxWidth: { xs: "340px", sm: "380px", md: "320px" },
                                        height: "auto",
                                        right: {
                                            xs: "0px",
                                            sm: "20px",
                                            md: "140px",
                                        },
                                        bottom: 0,
                                    },

                                ]}
                            />
                        </picture>}

                    </Grid>
                </Grid>
            </BgLayout>
            <DownloadLine appPageData={appPageData} />
            <Advantages advantages={appPageData.advantages} />
            <Description appPageData={appPageData} />
            <AppOffers appPageData={appPageData} />
            <DownloadLine appPageData={appPageData} />
            <OftenAsked appPageData={appPageData} />
            <Ratings />
            <PartnersLine bgcolor='transparent' />
        </div>
    )
}
